import { createContext, useCallback, useContext, useRef, useState } from 'react';
import { createPortal } from 'react-dom';

const ConfirmContext = createContext(null);

export function ConfirmProvider({ children }) {
  const [pending, setPending] = useState(null);
  const resolveRef = useRef(null);

  const confirm = useCallback(
    (message, { danger = false, confirmLabel = 'Confirm', cancelLabel = 'Cancel' } = {}) =>
      new Promise((resolve) => {
        resolveRef.current = resolve;
        setPending({ message, danger, confirmLabel, cancelLabel });
      }),
    []
  );

  const handleConfirm = () => {
    setPending(null);
    resolveRef.current?.(true);
  };

  const handleCancel = () => {
    setPending(null);
    resolveRef.current?.(false);
  };

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      {pending &&
        createPortal(
          <div className="modal-overlay" onClick={handleCancel}>
            <div
              className="modal-card"
              style={{ maxWidth: 420 }}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="modal-body" style={{ padding: '28px 28px 24px', display: 'flex', flexDirection: 'column', gap: 24 }}>
                <p style={{ margin: 0, fontSize: '1rem', lineHeight: 1.6, color: 'var(--text-primary)', whiteSpace: 'pre-line' }}>
                  {pending.message}
                </p>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
                  <button className="btn btn-ghost" onClick={handleCancel}>
                    {pending.cancelLabel}
                  </button>
                  <button
                    className={`btn ${pending.danger ? 'btn-danger' : 'btn-primary'}`}
                    onClick={handleConfirm}
                    autoFocus
                  >
                    {pending.confirmLabel}
                  </button>
                </div>
              </div>
            </div>
          </div>,
          document.body
        )}
    </ConfirmContext.Provider>
  );
}

export const useConfirm = () => useContext(ConfirmContext);
